import reloadApp from '../../common/reloadApp.js'
import {needsAppReloadSelector} from '../../data/serverInfo.js'
import {useSelector} from '../../store.js'

export default function ReloadMessage() {
  const needsAppReload = useSelector(needsAppReloadSelector)

  if (!needsAppReload) {
    return null
  }

  return (
    <div className="wrap--reload-app-msg full-width">
      <div className="row">
        <div className="medium-12 columns">
          <p className="fs-00 lh-sm margin-bottom-0 align-center">
            <button
              className="btn btn--link lightest"
              onClick={() => reloadApp()}
            >
              <strong>
                Please reload the page for the latest version of Ordoro
              </strong>
            </button>
          </p>
        </div>
      </div>
    </div>
  )
}
